import React from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';
import { getRankingLables, getRankingData } from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import './GraphComponent.css';
import { headingsValue, OPTIONSENUM } from '../licenseAnalyticsSupport/filtersOptions';
import { shortenNumber } from '../licenseAnalyticsSupport/calculationsUtils';
import { useTranslation } from 'react-i18next';

const rankingArray: number[] = [];
for (let i = 60; i >= 0; i--) {
  rankingArray.push(i);
}

const RankingComponent: React.FC = () => {
  const [t] = useTranslation();
  const rankingLables = useSelector(getRankingLables);
  let rankingData:any = useSelector(state => getRankingData(state, t));
  const alterSeries = rankingData?.series.map((ranking:any) => {
    const reverseRanking = ranking.data.map((d:any) => {
      return 60 - d;
    });
    return { ...ranking, data: [...reverseRanking] };
  });
  rankingData = { colors: [...rankingData?.colors], series: [...alterSeries] };

  let series = rankingData?.series;
  if (!series || series.length == 0) {
    series = [{ name: 'CLUB', data: [0, 0, 0, 0, 0] }];
  }
  const options:any = {
    legend: {
      showForSingleSeries: true,
    },
    colors: rankingData?.colors,
    chart: {
      height: 350,
      type: 'radar',
      dropShadow: {
        enabled: true,
        blur: 1,
        left: 1,
        top: 1,
      },
      toolbar: {
        show: false,
      },
    },
    markers: {
      size: 3,
      labels: {
        formatter: shortenNumber,
      },
    },
    xaxis: {
      categories: rankingLables.map((label:OPTIONSENUM) => t(headingsValue[label]?.name)),
      labels: {
        style: {
          colors: ["#000000","#000000", "#000000","#000000","#000000"],
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
      },
    },
    yaxis: {
      show: false,
      tickAmount: 6,
      categories: rankingArray,
      min: 0,
      max: 60,
    },
    tooltip: {
      y: {
        formatter: function(value:any, {}) {
          return 60 - value;
        },
      },
    },
  };

  return (
    <div className="chart" style={{ marginTop: '80px' }} id="chart">
      <div className="title">
        {t('RANKING')}
        <h4 style={{ fontWeight: '100' }}>{t('RANKING_LABEL')}</h4>
      </div>
      <Chart options={options} series={series} type="radar" height={450} />
    </div>
  );
};

export default RankingComponent;
